// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
    body {
  margin: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 0px;
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.container {
  padding: 1.25rem;
}
/* ===== HERO FORCE FIX (вернёт зелёный фон и белый текст) ===== */
.hero {
        position: relative !important;
        display: block !important;
        width: 100% !important;
        text-align: center !important;
        color: #fff !important;
        padding: 5rem 1.25rem !important; /* = py-20 px-5 */
        background: linear-gradient(to bottom, #1d3d3d 75%, #ffffff 75%) !important;
    }
.hero h1 {
        font-size: 3rem !important;
        margin: 0 !important;
        font-weight: 400 !important;
    }
.hero h2 {
        font-size: 1.6rem !important;
        margin-top: 14px !important;
        font-weight: 400 !important;
        color: #e0f0ef !important;
    }
.footer {
  margin-top: 1.25rem;
  text-align: center;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgb(47 79 79 / var(--tw-text-opacity, 1));
}
.section {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.25rem;
}
.card {
  width: 100%;
  max-width: 56rem;
  border-radius: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity, 1));
  padding: 1.25rem;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.card-title {
  margin-bottom: 0.625rem;
  font-size: 1.5rem;
  line-height: 2rem;
  --tw-text-opacity: 1;
  color: rgb(47 79 79 / var(--tw-text-opacity, 1));
}
.card-text p {
  margin-bottom: 1rem;
  line-height: 1.625;
}
.card-text ul {
  margin: 0px;
  list-style-type: disc;
  padding-left: 1.25rem;
}
.card-text li {
  margin-bottom: 0.5rem;
}
/* ===== CONTACT ICONS (position stays the same) ===== */
.contact-icons {
  position: fixed;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 1000;
  display: flex;
  gap: 1rem;
}
/* ===== FIX: glass look + correct layers (applies to all 3 icons) ===== */
.Btn, .Btnstock, .Btninsta {
        border-radius: 12px;
    }
.svgContainer, .svgContainerstock, .svgContainerinsta {
        border-radius: 12px;
        z-index: 2;

        /* glass */
        background-color: rgba(255, 255, 255, 0.14);
        backdrop-filter: blur(6px);
    }
.BG, .BGstock, .BGinsta {
        z-index: 1;
        border-radius: 12px;
    }
/* ===== TELEGRAM ===== */
.Btn {
        width: 45px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background-color: transparent;
        position: relative;
        cursor: pointer;
        transition: all 0.3s;
    }
.svgContainer {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 0.8px;
        transition: all 0.3s;
        border: 1px solid rgba(156, 156, 156, 0.466);
    }
.BG {
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        background: #24a1de;
        pointer-events: none;
        transition: all 0.3s;
    }
.Btn:hover .BG {
        transform: rotate(35deg);
        transform-origin: bottom;
    }
.Btn:hover .svgContainer {
        border: 1px solid rgba(226, 226, 226, 0.466);
        background-color: rgba(255, 255, 255, 0.22);
        backdrop-filter: blur(8px);
    }
/* ===== FACEBOOK ===== */
.Btnstock {
        width: 45px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background-color: transparent;
        position: relative;
        cursor: pointer;
        transition: all 0.3s;
    }
.svgContainerstock {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 0.8px;
        transition: all 0.3s;
        border: 1px solid rgba(156, 156, 156, 0.466);
    }
.BGstock {
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        background: #1877f2;
        pointer-events: none;
        transition: all 0.3s;
    }
.Btnstock:hover .BGstock {
        transform: rotate(35deg);
        transform-origin: bottom;
    }
.Btnstock:hover .svgContainerstock {
        background-color: rgba(255, 255, 255, 0.22);
        backdrop-filter: blur(8px);
    }
/* ===== INSTAGRAM ===== */
.Btninsta {
        width: 45px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background-color: transparent;
        position: relative;
        cursor: pointer;
        transition: all 0.3s;
    }
.svgContainerinsta {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 0.8px;
        transition: all 0.3s;
        border: 1px solid rgba(156, 156, 156, 0.466);
    }
.BGinsta {
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        background: linear-gradient(
                45deg,
                #f09433 0%,
                #e6683c 25%,
                #dc2743 50%,
                #cc2366 75%,
                #bc1888 100%
        );
        pointer-events: none;
        transition: all 0.3s;
    }
.Btninsta:hover .BGinsta {
        transform: rotate(35deg);
        transform-origin: bottom;
    }
.Btninsta:hover .svgContainerinsta {
        background-color: rgba(255, 255, 255, 0.20);
        backdrop-filter: blur(8px);
    }
/* ===== PHOTO ===== */
.photo-wrapper {
  position: relative;
  margin-top: 7rem;
  margin-bottom: 3.5rem;
  display: flex;
  justify-content: center;
        top: 50px;
        z-index: 5;              /* ниже, чем QR/соц */
        pointer-events: none;    /* важно: клики проходят сквозь фото */
}
.photo-card, .stack { pointer-events: auto; }
/* но фото остаётся кликабельным */
.stack {
  position: relative;
  height: 320px;
  width: 320px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.stack:hover {
        transform: rotate(5deg);
    }
.photo-card {
  position: relative;
  height: 100%;
  width: 100%;
  cursor: pointer;
  border-width: 8px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 0px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.photo-card::before,
    .photo-card::after {
        content: "";
        display: block;
        position: absolute;
        height: 100%;
        width: 100%;
        border: 2px solid white;
        background-color: white;
        z-index: -1;
        transition: all 150ms ease-in-out;
        top: 0;
        left: 0;
        transform-origin: center;
    }
.photo-card::before {
        transform: translate(-2%, -2%) rotate(-2deg);
    }
.photo-card::after {
        transform: translate(2%, 2%) rotate(2deg);
    }
.image {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.bottom-0 {
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.left-5 {
  left: 1.25rem;
}
.left-\\[-75\\%\\] {
  left: -75%;
}
.right-0 {
  right: 0px;
}
.right-5 {
  right: 1.25rem;
}
.top-0 {
  top: 0px;
}
.top-5 {
  top: 1.25rem;
}
.z-20 {
  z-index: 20;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.h-\\[20\\%\\] {
  height: 20%;
}
.h-\\[60\\%\\] {
  height: 60%;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.w-1\\/2 {
  width: 50%;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-full {
  width: 100%;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1;
}
.rotate-12 {
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.flex-col {
  flex-direction: column;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.gap-8 {
  gap: 2rem;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.overflow-hidden {
  overflow: hidden;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-bl-lg {
  border-bottom-left-radius: 0.5rem;
}
.rounded-br-lg {
  border-bottom-right-radius: 0.5rem;
}
.rounded-tl-lg {
  border-top-left-radius: 0.5rem;
}
.rounded-tr-lg {
  border-top-right-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.bg-blue-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-white\\/40 {
  background-color: rgb(255 255 255 / 0.4);
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.from-yellow-400 {
  --tw-gradient-from: #facc15 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 204 21 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-amber-500 {
  --tw-gradient-to: #f59e0b var(--tw-gradient-to-position);
}
.object-cover {
  object-fit: cover;
}
.p-2 {
  padding: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.text-\\[\\#3a2f00\\] {
  --tw-text-opacity: 1;
  color: rgb(58 47 0 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-gray-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity, 1));
}
.blur-lg {
  --tw-blur: blur(16px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@media (max-width: 600px) {
        .hero h1 {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

        .photo-wrapper {
    margin-top: 0px;
    margin-bottom: 2.5rem;
  }

        .stack {
    height: 220px;
    width: 220px;
  }

        .card {
    width: 100%;
    padding: 1rem;
  }

        .contact-icons {
            position: fixed;
            top: 16px;
            right: 16px;
            display: flex;
            gap: 16px;
            z-index: 50000;          /* выше всего */
            pointer-events: auto;
        }
    }
.lang-switch-wrapper {
        display: flex;
        justify-content: center;
        margin-top: 12px;
        margin-bottom: 18px;
    }
/* ===== GLOBAL TOP GREEN GRADIENT (FORCED) ===== */
body::before {
        content: "";
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 380px; /* высота зелёной зоны */
        background: linear-gradient(
                to bottom,
                #1d3d3d 0%,
                #1d3d3d 65%,
                rgba(29, 61, 61, 0) 100%
        );
        z-index: -1;
        pointer-events: none;
    }
/* ===== Card page layout ===== */
/* ===== UIverse Card (renamed to avoid конфликт с твоей .card) ===== */
/* QR on MAIN (top-left) */
.qr-main-wrapper {
        position: fixed;
        top: 16px;
        left: 16px;
        z-index: 50000;         /* выше всего */
        display: block;
        pointer-events: auto;
    }
.qr-glass-card, .qr-main-img { pointer-events: auto; }
/* сам “стеклянный” бокс */
.qr-glass-card {
        width: 60px;
        height: 75px;
        background: rgba(217, 217, 217, 0.58);
        border: 1px solid rgba(255,255,255,0.9);
        box-shadow: 12px 17px 51px rgba(0, 0, 0, 0.22);
        backdrop-filter: blur(6px);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.25s ease, border 0.25s ease;
    }
.qr-glass-card:hover {
        transform: scale(1.06);
        border: 1px solid rgba(0,0,0,0.45);
    }
/* картинка QR */
.qr-main-img {
        width: 48px;
        height: 48px;
        border-radius: 10px;
        background: #fff;
        display: block;
    }
/* увеличивается сам QR при hover карточки */
.qr-glass-card:hover .qr-main-img {
        transform: scale(1.08);
    }
/* ===== /card hero area (green gradient block) ===== */
.card-hero {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 420px;
        background: linear-gradient(to bottom, #1d3d3d 0%, #1d3d3d 65%, rgba(29, 61, 61, 0) 100%);
        z-index: -9999;        /* гарантированно ниже всего */
        pointer-events: none;
    }
/* ===== QR in corner on /card (bigger) ===== */
.qr-corner {
        position: fixed;
        top: 16px;
        left: 16px;
        z-index: 50000;
        display: block;
        width: 140px;
        height: 140px;
        border-radius: 18px;
        overflow: hidden;
        box-shadow: 0 14px 35px rgba(0, 0, 0, 0.25);
        background: #fff;
        pointer-events: auto;
    }
.qr-corner-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
/* ===== Social pill buttons — BEAUTIFUL VERSION (restored) ===== */
.social-pill {
        position: fixed;
        background: transparent;
        padding: 14px 30px;

        display: inline-flex;
        align-items: center;
        justify-content: center;

        font-size: 22px;
        font-weight: 700;
        text-decoration: none;

        border-radius: 999px;
        cursor: pointer;

        z-index: 10000;
        pointer-events: auto;

        overflow: hidden;                 /* ВАЖНО: держит анимацию внутри */
        transition: transform 0.2s ease, color 0.3s 0.1s ease-out;
    }
/* круг-заливка */
.social-pill::before {
        position: absolute;
        top: 50%;
        left: 50%;
        content: "";
        width: 340px;                     /* фиксируем, чтобы НЕ раздувало */
        height: 340px;
        transform: translate(-50%, -50%) scale(0);
        border-radius: 50%;
        z-index: -1;
        transition: transform 0.45s ease-out;
        pointer-events: none
    }
/* hover */
.social-pill:hover {
        color: #fff;
        transform: translateY(-1px);
    }
.social-pill:hover::before {
        transform: translate(-50%, -50%) scale(1);
    }
/* ===== Individual colors ===== */
.ig-pill {
        left: 420px;
        top: 420px;                        /* у белой зоны */
        border: 2px solid rgb(255, 0, 0);
        color: rgb(255, 0, 0);
    }
.ig-pill::before { background: rgb(255, 0, 0); }
.fb-pill {
        right: 420px;
        top: 420px;                        /* у белой зоны */
        border: 2px solid #0163E0;
        color: #0163E0;
    }
.fb-pill::before { background: #0163E0; }
.tg-pill {
        left: 50%;
        top: 520px;                        /* ниже */
        transform: translateX(-50%);
        border: 2px solid rgb(36, 161, 222);
        color: rgb(36, 161, 222);
    }
.tg-pill::before { background: rgb(36, 161, 222); }
/* чтобы hover у tg не ломал translateX */
.tg-pill:hover {
        transform: translateX(-50%) translateY(-1px);
    }
/* ===== Contact info box near QR (/card) ===== */
.contact-box{
        position: fixed;

        /* по центру между Instagram и Facebook */
        top: 300px;                 /* та же линия, что у кнопок */
        left: 50%;
        transform: translateX(-50%);

        padding: 18px 28px;
        border-radius: 18px;

        background: rgba(255, 255, 255, 0.65);
        backdrop-filter: blur(10px);

        box-shadow: 0 14px 35px rgba(0,0,0,0.25);

        text-align: center;

        font-size: 20px;            /* ⬅ крупно */
        font-weight: 600;
        line-height: 1.5;

        color: #111;

        z-index: 9000;
    }
.contact-box div + div{
        margin-top: 6px;
    }
/* ===== FORCE STICKY CORNERS (ALWAYS ON TOP) ===== */
.contact-icons{
        position: fixed !important;
        top: 16px !important;
        right: 16px !important;
        z-index: 999999 !important;
        pointer-events: auto !important;
    }
.qr-main-wrapper{
        position: fixed !important;
        top: 16px !important;
        left: 16px !important;
        z-index: 999999 !important;
        pointer-events: auto !important;
    }
/* чтобы клики точно не блокировались */
.qr-glass-card,
    .qr-main-img,
    .Btn, .Btnstock, .Btninsta{
        pointer-events: auto !important;
    }
/* на всякий случай: если где-то есть "липкий" контейнер */
html, body{
        overflow-x: hidden;
    }
.hover\\:scale-\\[1\\.03\\]:hover {
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:bg-blue-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-blue-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(37 99 235 / var(--tw-ring-opacity, 1));
}
.group:hover .group-hover\\:left-\\[125\\%\\] {
  left: 125%;
}
.group:hover .group-hover\\:h-\\[90\\%\\] {
  height: 90%;
}
@media (min-width: 1024px) {

  .lg\\:w-2\\/5 {
    width: 40%;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;IAAd;EAAA,WAAc;EAAd,kBAAc;EAAd,4DAAc;EAAd,YAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAWZ;EAAA;AAAU;AAGd,kEAAkE;AAClE;QACI,6BAA6B;QAC7B,yBAAyB;QACzB,sBAAsB;QACtB,6BAA6B;QAC7B,sBAAsB;QACtB,gCAAgC,EAAE,iBAAiB;QACnD,2EAA2E;IAC/E;AAEA;QACI,0BAA0B;QAC1B,oBAAoB;QACpB,2BAA2B;IAC/B;AAEA;QACI,4BAA4B;QAC5B,2BAA2B;QAC3B,2BAA2B;QAC3B,yBAAyB;IAC7B;AAGI;EAAA,mBAAgD;EAAhD,kBAAgD;EAAhD,eAAgD;EAAhD,mBAAgD;EAAhD,oBAAgD;EAAhD;AAAgD;AAIhD;EAAA,kBAAyD;EAAzD,aAAyD;EAAzD,mBAAyD;EAAzD,eAAyD;EAAzD,uBAAyD;EAAzD;AAAyD;AAIzD;EAAA,WAA6D;EAA7D,gBAA6D;EAA7D,sBAA6D;EAA7D,kBAA6D;EAA7D,4DAA6D;EAA7D,gBAA6D;EAA7D,6EAA6D;EAA7D,iGAA6D;EAA7D;AAA6D;AAI7D;EAAA,uBAAqC;EAArC,iBAAqC;EAArC,iBAAqC;EAArC,oBAAqC;EAArC;AAAqC;AAIrC;EAAA,mBAA2B;EAA3B;AAA2B;AAI3B;EAAA,WAAyB;EAAzB,qBAAyB;EAAzB;AAAyB;AAIzB;EAAA;AAAW;AAGf,wDAAwD;AAEpD;EAAA,eAA8C;EAA9C,YAA8C;EAA9C,cAA8C;EAA9C,aAA8C;EAA9C,aAA8C;EAA9C;AAA8C;AAGlD,0EAA0E;AAC1E;QACI,mBAAmB;IACvB;AAEA;QACI,mBAAmB;QACnB,UAAU;;QAEV,UAAU;QACV,2CAA2C;QAC3C,0BAA0B;IAC9B;AAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AAEA,yBAAyB;AACzB;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;QACZ,6BAA6B;QAC7B,kBAAkB;QAClB,eAAe;QACf,oBAAoB;IACxB;AAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,qBAAqB;QACrB,oBAAoB;QACpB,4CAA4C;IAChD;AAEA;QACI,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,oBAAoB;QACpB,oBAAoB;IACxB;AAEA;QACI,wBAAwB;QACxB,wBAAwB;IAC5B;AAEA;QACI,4CAA4C;QAC5C,2CAA2C;QAC3C,0BAA0B;IAC9B;AAEA,yBAAyB;AACzB;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;QACZ,6BAA6B;QAC7B,kBAAkB;QAClB,eAAe;QACf,oBAAoB;IACxB;AAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,qBAAqB;QACrB,oBAAoB;QACpB,4CAA4C;IAChD;AAEA;QACI,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,oBAAoB;QACpB,oBAAoB;IACxB;AAEA;QACI,wBAAwB;QACxB,wBAAwB;IAC5B;AAEA;QACI,2CAA2C;QAC3C,0BAA0B;IAC9B;AAEA,0BAA0B;AAC1B;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;QACZ,6BAA6B;QAC7B,kBAAkB;QAClB,eAAe;QACf,oBAAoB;IACxB;AAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,qBAAqB;QACrB,oBAAoB;QACpB,4CAA4C;IAChD;AAEA;QACI,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,YAAY;QACZ;;;;;;;SAOC;QACD,oBAAoB;QACpB,oBAAoB;IACxB;AAEA;QACI,wBAAwB;QACxB,wBAAwB;IAC5B;AAEA;QACI,2CAA2C;QAC3C,0BAA0B;IAC9B;AAEA,sBAAsB;AAElB;EAAA,kBAA+C;EAA/C,gBAA+C;EAA/C,qBAA+C;EAA/C,aAA+C;EAA/C,uBAA+C;QAC/C,SAAS;QACT,UAAU,eAAe,qBAAqB;QAC9C,oBAAoB,KAAK,sCAAsC;AAHhB;AAKnD,sBAAsB,oBAAoB,EAAE;AAAE,kCAAkC;AAG5E;EAAA,kBAAuE;EAAvE,aAAuE;EAAvE,YAAuE;EAAvE,wJAAuE;EAAvE,0BAAuE;EAAvE;AAAuE;AAG3E;QACI,uBAAuB;IAC3B;AAGI;EAAA,kBAA0G;EAA1G,YAA0G;EAA1G,WAA0G;EAA1G,eAA0G;EAA1G,iBAA0G;EAA1G,kBAA0G;EAA1G,4DAA0G;EAA1G,YAA0G;EAA1G,wJAA0G;EAA1G,0BAA0G;EAA1G;AAA0G;AAG9G;;QAEI,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,uBAAuB;QACvB,uBAAuB;QACvB,WAAW;QACX,iCAAiC;QACjC,MAAM;QACN,OAAO;QACP,wBAAwB;IAC5B;AAEA;QACI,4CAA4C;IAChD;AAEA;QACI,yCAAyC;IAC7C;AAGI;EAAA,YAAiC;EAAjC,WAAiC;EAAjC;AAAiC;AAtRzC;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AA2Rf;QAEQ;IAAA,mBAAe;IAAf;EAAe;;QAIf;IAAA,eAAiB;IAAjB;EAAiB;;QAIjB;IAAA,aAA0B;IAA1B;EAA0B;;QAI1B;IAAA,WAAiB;IAAjB;EAAiB;;QAGrB;YACI,eAAe;YACf,SAAS;YACT,WAAW;YACX,aAAa;YACb,SAAS;YACT,cAAc,WAAW,eAAe;YACxC,oBAAoB;QACxB;IACJ;AAEA;QACI,aAAa;QACb,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;IACvB;AAeA,mDAAmD;AACnD;QACI,WAAW;QACX,eAAe;QACf,MAAM;QACN,OAAO;QACP,WAAW;QACX,aAAa,EAAE,wBAAwB;QACvC;;;;;SAKC;QACD,WAAW;QACX,oBAAoB;IACxB;AACA,iCAAiC;AASjC,uEAAuE;AAgDvE,0BAA0B;AAC1B;QACI,eAAe;QACf,SAAS;QACT,UAAU;QACV,cAAc,UAAU,eAAe;QACvC,cAAc;QACd,oBAAoB;IACxB;AACA,+BAA+B,oBAAoB,EAAE;AAErD,0BAA0B;AAC1B;QACI,WAAW;QACX,YAAY;QACZ,qCAAqC;QACrC,uCAAuC;QACvC,8CAA8C;QAC9C,0BAA0B;QAC1B,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,mDAAmD;IACvD;AAEA;QACI,sBAAsB;QACtB,kCAAkC;IACtC;AAEA,gBAAgB;AAChB;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,cAAc;IAClB;AAGA,4CAA4C;AAC5C;QACI,sBAAsB;IAC1B;AACA,uDAAuD;AACvD;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,WAAW;QACX,aAAa;QACb,yFAAyF;QACzF,cAAc,SAAS,8BAA8B;QACrD,oBAAoB;IACxB;AAEA,+CAA+C;AAC/C;QACI,eAAe;QACf,SAAS;QACT,UAAU;QACV,cAAc;QACd,cAAc;QACd,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,2CAA2C;QAC3C,gBAAgB;QAChB,oBAAoB;IACxB;AAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;AAEA,mEAAmE;AACnE;QACI,eAAe;QACf,uBAAuB;QACvB,kBAAkB;;QAElB,oBAAoB;QACpB,mBAAmB;QACnB,uBAAuB;;QAEvB,eAAe;QACf,gBAAgB;QAChB,qBAAqB;;QAErB,oBAAoB;QACpB,eAAe;;QAEf,cAAc;QACd,oBAAoB;;QAEpB,gBAAgB,kBAAkB,kCAAkC;QACpE,yDAAyD;IAC7D;AAEA,iBAAiB;AACjB;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,WAAW;QACX,YAAY,sBAAsB,kCAAkC;QACpE,aAAa;QACb,yCAAyC;QACzC,kBAAkB;QAClB,WAAW;QACX,oCAAoC;QACpC;IACJ;AAEA,UAAU;AACV;QACI,WAAW;QACX,2BAA2B;IAC/B;AACA;QACI,yCAAyC;IAC7C;AAEA,kCAAkC;AAClC;QACI,WAAW;QACX,UAAU,yBAAyB,iBAAiB;QACpD,gCAAgC;QAChC,qBAAqB;IACzB;AACA,mBAAmB,0BAA0B,EAAE;AAE/C;QACI,YAAY;QACZ,UAAU,yBAAyB,iBAAiB;QACpD,yBAAyB;QACzB,cAAc;IAClB;AACA,mBAAmB,mBAAmB,EAAE;AAExC;QACI,SAAS;QACT,UAAU,yBAAyB,SAAS;QAC5C,2BAA2B;QAC3B,mCAAmC;QACnC,wBAAwB;IAC5B;AACA,mBAAmB,6BAA6B,EAAE;AAElD,yCAAyC;AACzC;QACI,4CAA4C;IAChD;AAEA,iDAAiD;AAwBjD;QACI,eAAe;;QAEf,yCAAyC;QACzC,UAAU,kBAAkB,8BAA8B;QAC1D,SAAS;QACT,2BAA2B;;QAE3B,kBAAkB;QAClB,mBAAmB;;QAEnB,qCAAqC;QACrC,2BAA2B;;QAE3B,wCAAwC;;QAExC,kBAAkB;;QAElB,eAAe,aAAa,aAAa;QACzC,gBAAgB;QAChB,gBAAgB;;QAEhB,WAAW;;QAEX,aAAa;IACjB;AAEA;QACI,eAAe;IACnB;AACA,qDAAqD;AACrD;QACI,0BAA0B;QAC1B,oBAAoB;QACpB,sBAAsB;QACtB,0BAA0B;QAC1B,+BAA+B;IACnC;AAEA;QACI,0BAA0B;QAC1B,oBAAoB;QACpB,qBAAqB;QACrB,0BAA0B;QAC1B,+BAA+B;IACnC;AAEA,uCAAuC;AACvC;;;QAGI,+BAA+B;IACnC;AAEA,0DAA0D;AAC1D;QACI,kBAAkB;IACtB;AAtoBJ;EAAA,kBAuoBC;EAvoBD,kBAuoBC;EAvoBD;AAuoBC;AAvoBD;EAAA,kBAuoBC;EAvoBD;AAuoBC;AAvoBD;EAAA,kBAuoBC;EAvoBD;AAuoBC;AAvoBD;EAAA,2GAuoBC;EAvoBD,yGAuoBC;EAvoBD;AAuoBC;AAvoBD;EAAA,oBAuoBC;EAvoBD;AAuoBC;AAvoBD;EAAA;AAuoBC;AAvoBD;EAAA;AAuoBC;AAvoBD;;EAAA;IAAA;EAuoBC;;EAvoBD;IAAA;EAuoBC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n    body {\n        @apply bg-white font-sans m-0 p-0;\n    }\n}\n\n@layer components {\n    .container {\n        @apply p-5;\n    }\n\n    /* ===== HERO FORCE FIX (вернёт зелёный фон и белый текст) ===== */\n    .hero {\n        position: relative !important;\n        display: block !important;\n        width: 100% !important;\n        text-align: center !important;\n        color: #fff !important;\n        padding: 5rem 1.25rem !important; /* = py-20 px-5 */\n        background: linear-gradient(to bottom, #1d3d3d 75%, #ffffff 75%) !important;\n    }\n\n    .hero h1 {\n        font-size: 3rem !important;\n        margin: 0 !important;\n        font-weight: 400 !important;\n    }\n\n    .hero h2 {\n        font-size: 1.6rem !important;\n        margin-top: 14px !important;\n        font-weight: 400 !important;\n        color: #e0f0ef !important;\n    }\n\n    .footer {\n        @apply text-center mt-5 text-base text-[#2f4f4f];\n    }\n\n    .section {\n        @apply flex flex-row justify-center gap-5 flex-wrap mt-10;\n    }\n\n    .card {\n        @apply bg-[#f4f4f4] rounded-xl p-5 w-full max-w-4xl shadow-md;\n    }\n\n    .card-title {\n        @apply text-2xl text-[#2f4f4f] mb-2.5;\n    }\n\n    .card-text p {\n        @apply mb-4 leading-relaxed;\n    }\n\n    .card-text ul {\n        @apply list-disc pl-5 m-0;\n    }\n\n    .card-text li {\n        @apply mb-2;\n    }\n\n    /* ===== CONTACT ICONS (position stays the same) ===== */\n    .contact-icons {\n        @apply fixed top-5 right-5 flex gap-4 z-[1000];\n    }\n\n    /* ===== FIX: glass look + correct layers (applies to all 3 icons) ===== */\n    .Btn, .Btnstock, .Btninsta {\n        border-radius: 12px;\n    }\n\n    .svgContainer, .svgContainerstock, .svgContainerinsta {\n        border-radius: 12px;\n        z-index: 2;\n\n        /* glass */\n        background-color: rgba(255, 255, 255, 0.14);\n        backdrop-filter: blur(6px);\n    }\n\n    .BG, .BGstock, .BGinsta {\n        z-index: 1;\n        border-radius: 12px;\n    }\n\n    /* ===== TELEGRAM ===== */\n    .Btn {\n        width: 45px;\n        height: 45px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: none;\n        background-color: transparent;\n        position: relative;\n        cursor: pointer;\n        transition: all 0.3s;\n    }\n\n    .svgContainer {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        letter-spacing: 0.8px;\n        transition: all 0.3s;\n        border: 1px solid rgba(156, 156, 156, 0.466);\n    }\n\n    .BG {\n        position: absolute;\n        content: \"\";\n        width: 100%;\n        height: 100%;\n        background: #24a1de;\n        pointer-events: none;\n        transition: all 0.3s;\n    }\n\n    .Btn:hover .BG {\n        transform: rotate(35deg);\n        transform-origin: bottom;\n    }\n\n    .Btn:hover .svgContainer {\n        border: 1px solid rgba(226, 226, 226, 0.466);\n        background-color: rgba(255, 255, 255, 0.22);\n        backdrop-filter: blur(8px);\n    }\n\n    /* ===== FACEBOOK ===== */\n    .Btnstock {\n        width: 45px;\n        height: 45px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: none;\n        background-color: transparent;\n        position: relative;\n        cursor: pointer;\n        transition: all 0.3s;\n    }\n\n    .svgContainerstock {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        letter-spacing: 0.8px;\n        transition: all 0.3s;\n        border: 1px solid rgba(156, 156, 156, 0.466);\n    }\n\n    .BGstock {\n        position: absolute;\n        content: \"\";\n        width: 100%;\n        height: 100%;\n        background: #1877f2;\n        pointer-events: none;\n        transition: all 0.3s;\n    }\n\n    .Btnstock:hover .BGstock {\n        transform: rotate(35deg);\n        transform-origin: bottom;\n    }\n\n    .Btnstock:hover .svgContainerstock {\n        background-color: rgba(255, 255, 255, 0.22);\n        backdrop-filter: blur(8px);\n    }\n\n    /* ===== INSTAGRAM ===== */\n    .Btninsta {\n        width: 45px;\n        height: 45px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: none;\n        background-color: transparent;\n        position: relative;\n        cursor: pointer;\n        transition: all 0.3s;\n    }\n\n    .svgContainerinsta {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        letter-spacing: 0.8px;\n        transition: all 0.3s;\n        border: 1px solid rgba(156, 156, 156, 0.466);\n    }\n\n    .BGinsta {\n        position: absolute;\n        content: \"\";\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(\n                45deg,\n                #f09433 0%,\n                #e6683c 25%,\n                #dc2743 50%,\n                #cc2366 75%,\n                #bc1888 100%\n        );\n        pointer-events: none;\n        transition: all 0.3s;\n    }\n\n    .Btninsta:hover .BGinsta {\n        transform: rotate(35deg);\n        transform-origin: bottom;\n    }\n\n    .Btninsta:hover .svgContainerinsta {\n        background-color: rgba(255, 255, 255, 0.20);\n        backdrop-filter: blur(8px);\n    }\n\n    /* ===== PHOTO ===== */\n    .photo-wrapper {\n        @apply flex justify-center mt-28 mb-14 relative;\n        top: 50px;\n        z-index: 5;              /* ниже, чем QR/соц */\n        pointer-events: none;    /* важно: клики проходят сквозь фото */\n    }\n    .photo-card, .stack { pointer-events: auto; } /* но фото остаётся кликабельным */\n\n    .stack {\n        @apply w-[320px] h-[320px] transition duration-200 ease-in-out relative;\n    }\n\n    .stack:hover {\n        transform: rotate(5deg);\n    }\n\n    .photo-card {\n        @apply w-full h-full border-[8px] bg-white relative transition duration-150 ease-in-out cursor-pointer p-0;\n    }\n\n    .photo-card::before,\n    .photo-card::after {\n        content: \"\";\n        display: block;\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        border: 2px solid white;\n        background-color: white;\n        z-index: -1;\n        transition: all 150ms ease-in-out;\n        top: 0;\n        left: 0;\n        transform-origin: center;\n    }\n\n    .photo-card::before {\n        transform: translate(-2%, -2%) rotate(-2deg);\n    }\n\n    .photo-card::after {\n        transform: translate(2%, 2%) rotate(2deg);\n    }\n\n    .image {\n        @apply w-full h-full object-cover;\n    }\n}\n\n@layer utilities {\n    @media (max-width: 600px) {\n        .hero h1 {\n            @apply text-3xl;\n        }\n\n        .photo-wrapper {\n            @apply mt-0 mb-10;\n        }\n\n        .stack {\n            @apply w-[220px] h-[220px];\n        }\n\n        .card {\n            @apply w-full p-4;\n        }\n\n        .contact-icons {\n            position: fixed;\n            top: 16px;\n            right: 16px;\n            display: flex;\n            gap: 16px;\n            z-index: 50000;          /* выше всего */\n            pointer-events: auto;\n        }\n    }\n\n    .lang-switch-wrapper {\n        display: flex;\n        justify-content: center;\n        margin-top: 12px;\n        margin-bottom: 18px;\n    }\n\n    .lang-toggle {\n        padding: 8px 14px;\n        border-radius: 999px;\n        border: 1px solid rgba(0, 0, 0, 0.15);\n        background: rgba(255, 255, 255, 0.85);\n        color: #000;\n        font-weight: 600;\n        text-decoration: none;\n    }\n\n    .lang-toggle:hover {\n        background: #fff;\n    }\n    /* ===== GLOBAL TOP GREEN GRADIENT (FORCED) ===== */\n    body::before {\n        content: \"\";\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 380px; /* высота зелёной зоны */\n        background: linear-gradient(\n                to bottom,\n                #1d3d3d 0%,\n                #1d3d3d 65%,\n                rgba(29, 61, 61, 0) 100%\n        );\n        z-index: -1;\n        pointer-events: none;\n    }\n    /* ===== Card page layout ===== */\n    .card-page {\n        min-height: 100vh;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 40px 16px;\n    }\n\n    /* ===== UIverse Card (renamed to avoid конфликт с твоей .card) ===== */\n    .qr-card {\n        box-sizing: border-box;\n        width: 220px;\n        height: 150px;\n        max-width: 92vw;\n\n        background: rgba(217, 217, 217, 0.58);\n        border: 1px solid white;\n        box-shadow: 12px 17px 51px rgba(0, 0, 0, 0.22);\n        backdrop-filter: blur(6px);\n        border-radius: 17px;\n\n        text-align: center;\n        cursor: pointer;\n        transition: all 0.5s;\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        user-select: none;\n        font-weight: bolder;\n        color: black;\n    }\n\n    .qr-card-inner {\n        width: 100%;\n        padding: 18px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 14px;\n    }\n\n    .qr-image {\n        width: 260px;\n        max-width: 78vw;\n        height: auto;\n        border-radius: 14px;\n        background: white;\n    }\n\n    .qr-caption {\n        font-size: 20px;\n        letter-spacing: 2px;\n    }\n    /* QR on MAIN (top-left) */\n    .qr-main-wrapper {\n        position: fixed;\n        top: 16px;\n        left: 16px;\n        z-index: 50000;         /* выше всего */\n        display: block;\n        pointer-events: auto;\n    }\n    .qr-glass-card, .qr-main-img { pointer-events: auto; }\n\n    /* сам “стеклянный” бокс */\n    .qr-glass-card {\n        width: 60px;\n        height: 75px;\n        background: rgba(217, 217, 217, 0.58);\n        border: 1px solid rgba(255,255,255,0.9);\n        box-shadow: 12px 17px 51px rgba(0, 0, 0, 0.22);\n        backdrop-filter: blur(6px);\n        border-radius: 12px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: transform 0.25s ease, border 0.25s ease;\n    }\n\n    .qr-glass-card:hover {\n        transform: scale(1.06);\n        border: 1px solid rgba(0,0,0,0.45);\n    }\n\n    /* картинка QR */\n    .qr-main-img {\n        width: 48px;\n        height: 48px;\n        border-radius: 10px;\n        background: #fff;\n        display: block;\n    }\n\n\n    /* увеличивается сам QR при hover карточки */\n    .qr-glass-card:hover .qr-main-img {\n        transform: scale(1.08);\n    }\n    /* ===== /card hero area (green gradient block) ===== */\n    .card-hero {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 420px;\n        background: linear-gradient(to bottom, #1d3d3d 0%, #1d3d3d 65%, rgba(29, 61, 61, 0) 100%);\n        z-index: -9999;        /* гарантированно ниже всего */\n        pointer-events: none;\n    }\n\n    /* ===== QR in corner on /card (bigger) ===== */\n    .qr-corner {\n        position: fixed;\n        top: 16px;\n        left: 16px;\n        z-index: 50000;\n        display: block;\n        width: 140px;\n        height: 140px;\n        border-radius: 18px;\n        overflow: hidden;\n        box-shadow: 0 14px 35px rgba(0, 0, 0, 0.25);\n        background: #fff;\n        pointer-events: auto;\n    }\n\n    .qr-corner-img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n\n    /* ===== Social pill buttons — BEAUTIFUL VERSION (restored) ===== */\n    .social-pill {\n        position: fixed;\n        background: transparent;\n        padding: 14px 30px;\n\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n\n        font-size: 22px;\n        font-weight: 700;\n        text-decoration: none;\n\n        border-radius: 999px;\n        cursor: pointer;\n\n        z-index: 10000;\n        pointer-events: auto;\n\n        overflow: hidden;                 /* ВАЖНО: держит анимацию внутри */\n        transition: transform 0.2s ease, color 0.3s 0.1s ease-out;\n    }\n\n    /* круг-заливка */\n    .social-pill::before {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        content: \"\";\n        width: 340px;                     /* фиксируем, чтобы НЕ раздувало */\n        height: 340px;\n        transform: translate(-50%, -50%) scale(0);\n        border-radius: 50%;\n        z-index: -1;\n        transition: transform 0.45s ease-out;\n        pointer-events: none\n    }\n\n    /* hover */\n    .social-pill:hover {\n        color: #fff;\n        transform: translateY(-1px);\n    }\n    .social-pill:hover::before {\n        transform: translate(-50%, -50%) scale(1);\n    }\n\n    /* ===== Individual colors ===== */\n    .ig-pill {\n        left: 420px;\n        top: 420px;                        /* у белой зоны */\n        border: 2px solid rgb(255, 0, 0);\n        color: rgb(255, 0, 0);\n    }\n    .ig-pill::before { background: rgb(255, 0, 0); }\n\n    .fb-pill {\n        right: 420px;\n        top: 420px;                        /* у белой зоны */\n        border: 2px solid #0163E0;\n        color: #0163E0;\n    }\n    .fb-pill::before { background: #0163E0; }\n\n    .tg-pill {\n        left: 50%;\n        top: 520px;                        /* ниже */\n        transform: translateX(-50%);\n        border: 2px solid rgb(36, 161, 222);\n        color: rgb(36, 161, 222);\n    }\n    .tg-pill::before { background: rgb(36, 161, 222); }\n\n    /* чтобы hover у tg не ломал translateX */\n    .tg-pill:hover {\n        transform: translateX(-50%) translateY(-1px);\n    }\n\n    /* ===== Contact info box near QR (/card) ===== */\n    .contact-info-box{\n        position: fixed;\n        top: 170px;          /* сразу под QR */\n        left: 16px;\n        z-index: 9999;\n\n        background: rgba(255,255,255,0.85);\n        backdrop-filter: blur(8px);\n\n        border-radius: 14px;\n        padding: 12px 14px;\n\n        font-size: 14px;\n        line-height: 1.4;\n        color: #1d3d3d;\n\n        box-shadow: 0 8px 24px rgba(0,0,0,0.18);\n    }\n\n    .contact-info-box strong{\n        display: block;\n        font-weight: 600;\n    }\n    .contact-box{\n        position: fixed;\n\n        /* по центру между Instagram и Facebook */\n        top: 300px;                 /* та же линия, что у кнопок */\n        left: 50%;\n        transform: translateX(-50%);\n\n        padding: 18px 28px;\n        border-radius: 18px;\n\n        background: rgba(255, 255, 255, 0.65);\n        backdrop-filter: blur(10px);\n\n        box-shadow: 0 14px 35px rgba(0,0,0,0.25);\n\n        text-align: center;\n\n        font-size: 20px;            /* ⬅ крупно */\n        font-weight: 600;\n        line-height: 1.5;\n\n        color: #111;\n\n        z-index: 9000;\n    }\n\n    .contact-box div + div{\n        margin-top: 6px;\n    }\n    /* ===== FORCE STICKY CORNERS (ALWAYS ON TOP) ===== */\n    .contact-icons{\n        position: fixed !important;\n        top: 16px !important;\n        right: 16px !important;\n        z-index: 999999 !important;\n        pointer-events: auto !important;\n    }\n\n    .qr-main-wrapper{\n        position: fixed !important;\n        top: 16px !important;\n        left: 16px !important;\n        z-index: 999999 !important;\n        pointer-events: auto !important;\n    }\n\n    /* чтобы клики точно не блокировались */\n    .qr-glass-card,\n    .qr-main-img,\n    .Btn, .Btnstock, .Btninsta{\n        pointer-events: auto !important;\n    }\n\n    /* на всякий случай: если где-то есть \"липкий\" контейнер */\n    html, body{\n        overflow-x: hidden;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
